import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "@app/core/route-guards/auth-guard.service";
import { AuthCallbackComponent } from "./ui-components/auth-callback";
import { AgeVerifiedGuard } from "./route-guards/age-verified.guard";

const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "auth-callback",
    component: AuthCallbackComponent,
    data: { layout: "fullpage" },
  },
  {
    path: "dashboard",
    canActivate: [AgeVerifiedGuard, AuthGuardService],
    loadChildren: "app/features/dashboard/dashboard.module#DashboardModule",
  },
  {
    path: "invoices",
    canActivate: [AgeVerifiedGuard, AuthGuardService],
    loadChildren: "app/features/invoices/invoices.module#InvoicesModule",
  },
  {
    path: "transactions",
    canActivate: [AgeVerifiedGuard, AuthGuardService],
    loadChildren:
      "app/features/transactions/transactions.module#TransactionsModule",
  },
  {
    path: "cards",
    canActivate: [AgeVerifiedGuard, AuthGuardService],
    loadChildren: "app/features/cards/cards.module#CardsModule",
  },
  {
    path: "free-liters",
    canActivate: [AgeVerifiedGuard, AuthGuardService],
    loadChildren:
      "app/features/free-liters/free-liters.module#FreeLitersModule",
  },
  {
    path: "user-profile",
    canActivate: [AgeVerifiedGuard, AuthGuardService],
    loadChildren:
      "app/features/user-profile/user-profile.module#UserProfileModule",
  },
  {
    path: "confirm-date-of-birth",
    loadChildren:
      "app/features/confirm-dob/confirm-dob.module#ConfirmDateOfBirthModule",
    canActivate: [AuthGuardService],
    data: { layout: "fullpage" },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
